import React from 'react';

const DriverContext = React.createContext({
    driverId: null as string | null,
    setDriverId: (id: React.SetStateAction<string | null>) => {},
});

export default DriverContext;